import { useCoordinatedOverlay as useInternalCoordinatedOverlay } from '#pplx/frontend/aether/internal/overlay/useOverlay.js';
import { createContext, useContext } from 'react';
export const NOOP_LOGGER = {
    warn: () => { },
    error: () => { },
};
export const AetherContext = createContext({
    logger: NOOP_LOGGER,
    isMobileStyle: false,
    isMobileUserAgent: false,
    portalTargetElement: null,
});
AetherContext.displayName = 'AetherContext';
export function useAetherContext() {
    return useContext(AetherContext);
}
/** Coordinates one manually controlled overlay with other Aether overlays. */
export function useCoordinatedOverlay() {
    return useInternalCoordinatedOverlay();
}
//# sourceMappingURL=useAetherContext.js.map